<template>
<div class="full">
    <div class="header">
        <div class="person">
            <img src="@/assets/image/message/tou.png" alt="头像">
            <div class="perMes">
                <p class="name">{{this.$store.state.user.user_name||'XXX'}}</p>
                <p class="exma_id">{{user.user_id_no || '111111111111111111'}}</p>
            </div>
            <span class="tit">
                {{this.$store.state.project.project_name}}<br>
                <label class="subject_name">{{this.$store.state.exam.cur_subject.subject_name}}</label>
            </span>
        </div>
        <div class="exam_detail">
            <div class="exam_msg">
                <p>机位：001</p>
                <p>剩余时间：{{timer}}</p>
            </div>
            <button class="btn submit" type="button" @click="submit">交卷</button>
        </div>
    </div>
    <div class=" main exam_body" :class="{'screen':is_full}">
        <div class="exam_left">
            <div v-for="(item,index) in part" :key="index">
                <p class="titPart">{{ item.name }}</p>

                <div>
                    
                    <template v-for="(topic,t) in all_question" >
                    <span class="topic_num" 
                    v-if="topic.part_display_order == item.display_order"

                    :class="{
                        'cur': cur_question_id == topic.question_id,
                        'key':key_arr.indexOf(topic.question_id)>-1,
                        'ed':Object.prototype.hasOwnProperty.call(answerItem, topic.question_id)
                        }"
                     
                     :key="t"
                     @click="changeTopic(topic)">{{topic.topic_num}}</span>
                    </template>
                </div>
            </div>
        </div>
        <div class="exam_right">
            
            <div class="part" v-if="part[topic.part_display_order]">
                <pre>{{ part[topic.part_display_order].description || '' }}</pre>
            </div>
            <div class="exam_content" :class="'font'+set_font_size_btn[set_font_size_cur].size">
                <div class="shuiyin">
                    <label v-for="(item,index) in shuiyin" :key="index"> {{this.$store.state.user.exam_no||'111111111111111'}}</label>
                </div>
                <Question :topic="topic" @isFull="isFull" @doRadio="doRadio" style="position: relative"/>
            </div>
            <div class="bottom_btn">
                <span class="changeFull"  @click="is_full = !is_full" style="float: left;margin: 7px 30px 7px 7px;line-height:initial;cursor:pointer;">
                    <img src="~@/assets/image/exam/left.png" v-if="!is_full">
                    <img src="~@/assets/image/exam/right.png" v-if="is_full">
                </span>
                <div style="float:left;">
                    <div class="btn btn_primary" @click="upTopic">上一题</div>
                    <div class="btn btn_normal" @click="nextTopic">下一题</div>
                </div>
                <div class="btn btn_sm" :class="{'key':cur_question_key}" @click="key">{{cur_question_key?"取消":"标记"}}</div>
                <!-- 配置的显示按钮 -->
                <div class="btn btn_sm" v-for="(item,index) in btn_item" :key="index" @click="btnFz(item.name)">{{item.text}}</div>
                
                <div class="btn btn_normal set" @click="set_window_show = true;"></div>
                <div class="dropContents" v-show="set_window_show">
                    <span>
                        <a href="javascript:;" class="ch_auto" :class="{'current':auto_change_next_topic}" @click="auto_change_next_topic=true">自动切换到下一题</a>
                        <a href="javascript:;" class="ch_auto" :class="{'current':!auto_change_next_topic}" @click="auto_change_next_topic=false">手动切换到下一题</a>
                    </span>
                    <span>
                        <a v-for="(item,index) in set_font_size_btn" :key="index" href="javascript:;" class="changeBig" :class="{'current':index == set_font_size_cur}" @click="set_font_size_cur = index">{{item.title}}</a>
                    </span>
                    <span class="last">
                        <a href="javascript:;" class="changeFull current" @click="is_full = !is_full">切换显示</a>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Question from '../components/paper/question.vue'
import Config from "@/infrastructures/config"

export default {
    name: 'Exam',
    components: {
        Question,
        
        // Prompt
    },
    data() {
        return {
            //弹出框配置
           
            set_font_size_btn: [{
                    size: '100',
                    title: "原始大小"
                },
                // {
                //     size: '30',
                //     title: "缩小30%"
                // },
                // {
                //     size: '130',
                //     title: "放大30%"
                // },
                {
                    size: '150',
                    title: "放大50%"
                },
                {
                    size: '200',
                    title: "放大100%"
                },
            ],
            set_font_size_cur: 0,
            paper: [], //试卷
            topic: {}, //当前题，渲染题目用
            cur_question_id: "", //当前题的id
            key_arr: [], //标记的题目id
            cur_question_key: false, //当前题是否被标记

            is_full: false, //是否全屏
            set_window_show: false, //设置弹出框是否显示
            timer: "1:30:00", //默认显示的倒计时
            part:[],//试题部分
            all_question: [], //提取出来的所有试题
            auto_change_next_topic: false, //自动切换下一题

            btn_item:[],

            set_timer:null
        }
    },
    created() {

        this.getPaper();
        this.examCountDown();

        let subject_conf = this.$store.state.exam.cur_subject.subject_conf?JSON.parse(this.$store.state.exam.cur_subject.subject_conf).btn_item:false;
        if(subject_conf){
            let btn_item = [];
            for(var i in Config.btn_item){
                if(subject_conf.indexOf(Config.btn_item[i].id) >-1 ){
                    btn_item.push(Config.btn_item[i])
                }
            }
            this.btn_item = btn_item;
        }
        
        
    },
    mounted() {
        document.addEventListener('click', (e) => {

            if (e.target.className != 'btn btn_normal set') {

                this.set_window_show = false;
            }
        })
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        answerItem() {
            return this.$store.state.answer;
        },
        shuiyin(){
            var len = [];
            for(var i=0;i<0;i++ ){
                len.push(i)
            }
            return len
        }
    },
    beforeDestroy(){
        clearTimeout(this.set_timer);
    },
    methods: {


        //获取当前试卷所有试题
        getPaper() {
            let paper_id = this.$store.state.exam.cur_subject.paper_id;
            let standard_answer={};//标准答案


            this.$req.post("question/select", {
                paper_id: paper_id
            }).then(res => {
                if (res.flag == 1) {
                    //let all_question = []; //所有的试题，方便上下题索引

                    this.part = res.data.part;
                    let questions = res.data.question;
                    let index = 0;

                    for (let i in questions) {
                        index++;
                        questions[i].topic_num = index;
                        standard_answer[questions[i].question_id]={
                            answer: questions[i].answer,
                            score:questions[i].score
                        }
                    }

                    this.standard_answer = standard_answer;
                    this.all_question = res.data.question;
                    this.cur_question_id = questions[0].question_id;
                    this.changeTopic(questions[0]);

                    //如果需要记录日志并且没有存log_id,则请求记录开始作答的时间
                    if (this.$store.state.config.is_log && !this.$store.state.user.log_id) {
                        this.$req.post("log/log_exam_begin", {
                            user_id: this.$store.state.user.user_id,
                            paper_id
                        }).then(res => {
                            if (res.flag == 1) {
                                let user = this.$store.state.user;
                                user.log_id = res.data.log_id;
                                this.$store.commit("user", user);
                            }
                        })
                    }
                }
            })
        },

        //切换试题，渲染当前试题
        changeTopic(item) {
            //简答题blur需要触发保存，所以这里切换这里延时
            setTimeout(()=>{
                this.cur_question_id = item.question_id;
                this.topic = item;
                this.cur_question_key = this.key_arr.indexOf(this.cur_question_id) > -1;
            },5);
            

        },
        //点击标记
        key() {
            let key_arr = this.key_arr;
            let cur_question_id = this.cur_question_id;
            let index = key_arr.indexOf(cur_question_id);
            if (index > -1) {
                this.cur_question_key = false;
                key_arr.splice(index, 1);
            } else {
                this.cur_question_key = true;
                key_arr.push(cur_question_id)
            }
        },

        //点击全屏
        isFull(flag) {
            this.is_full = flag;
        },

        //点击交卷
        submit() {
            let all_question = this.all_question;
            let answer = this.$store.state.answer;
            
            let no_num = 0;
            for (let i in all_question) {
                if (!Object.prototype.hasOwnProperty.call(answer, all_question[i].question_id)) {
                    no_num++;
                }
            }
            if (no_num == 0) {
                this.endSubmit();
            } else {
                 let subject_name = this.$store.state.exam.cur_subject?this.$store.state.exam.cur_subject.subject_name:"";
                let this_ = this;
                this.$tip({
                    text:`${subject_name}还有${no_num}道题未作答，请确定全部答完后交卷！`,
                    btn:['确定交卷', '返回作答']
                },function(){
                    this_.endSubmit();
                })
            }
        },
        //最终交卷方法
        endSubmit() {
            if(this.$store.state.config.is_log && this.$store.state.user.log_id) {
                this.$req.post("log/log_exam_end", {
                    log_id: this.$store.state.user.log_id
                }).then(res => {
                    if (res.flag == 1) {
                        this.submitToPage();
                    }
                })
            }else{
                this.submitToPage();
            
            }
            
        },
        //获取分数
        getScore(){
            if(this.$store.state.config.is_show_score){
                let standard_answer = this.standard_answer;
                let answer = this.$store.state.answer;
                let score = 0;

                for(var i in answer){
                    //1单选、3判断、5简答
                    if(typeof(answer[i]) == 'string'){
                        if(answer[i] == standard_answer[i].answer){
                            score -= -standard_answer[i].score;
                            
                        }
                    }else{
                        //2多选、4填空
                        if(answer[i].length == standard_answer[i].answer.split(',').length){
                            let flag = true;
                            for(var j in answer[i]){
                                if(standard_answer[i].answer.indexOf(answer[i][j]) == -1){
                                    flag = false;
                                }
                            }
                            if(flag){
                                score -= -standard_answer[i].score;
                            }
                        }
                    }
                }
                return score+'';

            }else{
                return false;
            }
        },
        submitToPage(){
            let score = false;
            if(this.$store.state.config.is_show_score){
                score = this.getScore();
            }
            if(this.$store.state.config.is_series_exam && this.$store.state.config.is_series_exam == 1){
                
                /*
                    科目联考：类似初中级经济师
                    查找vuex 里exam.subject中是否有未作答的科目，如果有未作答的科目，进入路径/next,否则交卷

                */
                let exam = this.$store.state.exam;
                let subject = exam.subject;
                let no_doing_key;
                for(let i in subject){
                    if(!subject[i].use_status){
                        no_doing_key = i;
                        break;
                    }
                }
                
                if(no_doing_key){
                    exam.cur_subject = subject[no_doing_key];
                    exam.subject[no_doing_key].use_status = 'ing';
                    this.$store.commit("exam",exam);
                    this.$router.push({
                        name: "Next"
                        ,params:{project_code:this.$store.state.project.project_code}
                        ,query:{score}
                    });
                }else{
                    this.$router.push({
                        name: "Success"
                        ,params:{project_code:this.$store.state.project.project_code}
                        ,query:{score}
                    });
                }
                
            }else{
                //非科目联考
                this.$router.push({
                    name: "Success"
                    ,params:{project_code:this.$store.state.project.project_code}
                    ,query:{score}
                });
            }
        },

        //考试倒计时
        examCountDown() {
            var curTime = new Date().getTime();
            var djs = this.$store.state.exam.exam_end_time - curTime;
            
            if (djs >= 1000) {
                
                var hours = parseInt((djs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = parseInt((djs % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = parseInt((djs % (1000 * 60)) / 1000);

                this.timer = `${hours}：${minutes}：${seconds}`;
                let this_ = this;
                clearTimeout(this.set_timer);
                this.set_timer = setTimeout(function () {
                    this_.examCountDown();
                }, 1000)
            } else {
                this.timer = `0:0:0`;
                this.endSubmit();
            }

        },
        //上一题
        upTopic() {
            let all_question = this.all_question;
            let index = this.topic.topic_num-1;
            index = index == 0 ? 0 : index - 1;
            this.changeTopic(all_question[index])

        },
        //下一题
        nextTopic() {
            let all_question = this.all_question;
            let index = this.topic.topic_num-1;
            index = index == all_question.length ? all_question.length : index - (-1);
            if(all_question[index]){
                this.changeTopic(all_question[index])
            }
            
        },
       

        //选择完单选题之后,如果选了自动切换下一题，则触发自动切换下一题
        doRadio() {
            let this_ = this;
            setTimeout(function () {
                if (this_.auto_change_next_topic) {
                    this_.nextTopic();
                }
            }, 100)
        },
        //辅助按钮点击
        btnFz(item){
            if(item == 'jsq'){
                this.$tip(
                    {text:`实际考试中，您将使用考试系统内置的计算器程序，该程序和Windows操作系统自带的计算器（科学型、统计型）类似，如您希望提前熟悉相关操作，可按照以下步骤获取该程序：<br/> 1. 下载“PTCalc.zip”压缩包<br/> 2. 解压“PTCalc.zip”压缩包<br/> 3. 运行“PTCalc.EXE”程序`,
                    icon:"false",
                    btn:['下载','取消']
                    },function(){
                        //window.location.href = "http://51cpta-10004457.cos.myqcloud.com/PTCalc.zip"
                        window.location.href="./asset/file/PTCalc.zip"
                    }
                )
            }else{
                this.$tip({text:"模拟系统暂不支持该功能！"})

            } 
        },

      
    },
}
</script>

<style lang='scss' scoped src="../assets/css/exam.scss"></style>
